export default function isEmpty(a) {
	if(a === 0){
		return false;
	}
	return !a;
}



// WEBPACK FOOTER //
// ./src/util/isEmpty.js